import React, { useEffect, useState, useMemo } from "react";
import "./Hero.scss";

const Hero = (props) => {
  const [currentImageCounter, setCurrentImageCounter] = useState(0);
  const images = useMemo(() => props.images[0] || [], [props.images]);
  const nextImageDelay = props.imageTimer && props.imageTimer.length > 0 ? props.imageTimer[0] : 30000;

  useEffect(() => {
    if (images.length > 0) {
      const timer = setInterval(() => {
        setCurrentImageCounter((prevCounter) => (prevCounter + 1) % images.length);
      }, nextImageDelay);

      return () => clearInterval(timer);
    }
  }, [images, nextImageDelay]);

  return (
    <div id="hero">
      <div className="hero-slideshow">
        {images.map((image, index) => (
          <img
            key={image.sys.id}
            alt={image.fields.title || ""}
            src={image.fields.file.url}
            style={{ opacity: index === currentImageCounter ? 1 : 0 }}
          />
        ))}
      </div>
      <p id="slogan">{props.slogan}</p>
    </div>
  );
};

export default Hero;
